import { render, staticRenderFns } from "./EvaluacionDesempenioInstitucionalCardComponent.vue?vue&type=template&id=411ced48"
import script from "./EvaluacionDesempenioInstitucionalCardComponent.vue?vue&type=script&lang=js"
export * from "./EvaluacionDesempenioInstitucionalCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports